export default __webpack_public_path__ + "static/media/html.85b0a799.svg";